import * as tslib_1 from "tslib";
import { selectGroup } from 'owa-mail-folder-forest-actions';
import { lazyGroupHeaderCommandBarAction, lazyGroupHeaderNavigationButton, } from 'owa-group-header-actions';
import { lazySetSharePointItemsViewNavigationTargetPath } from 'owa-group-fileshub-actions';
import { ensureValidGroupSmtpAddress, } from '../utils/mailGroupRouteSettings';
export default function mailGroupFilesRouteHandler(parameters, allParameters) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var groupSmtp, commandBarAction, groupHeaderNavigationButton, spPath, setSharePointItemsViewNavigationTargetPath, realSpPath;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    groupSmtp = ensureValidGroupSmtpAddress(parameters);
                    if (!groupSmtp) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, lazyGroupHeaderCommandBarAction.import()];
                case 1:
                    commandBarAction = _a.sent();
                    return [4 /*yield*/, lazyGroupHeaderNavigationButton.import()];
                case 2:
                    groupHeaderNavigationButton = _a.sent();
                    commandBarAction(groupHeaderNavigationButton.Files);
                    return [4 /*yield*/, selectGroup(groupSmtp, 'groups')];
                case 3:
                    _a.sent();
                    spPath = allParameters && allParameters.length > 2 ? allParameters[2] : null;
                    return [4 /*yield*/, lazySetSharePointItemsViewNavigationTargetPath.import()];
                case 4:
                    setSharePointItemsViewNavigationTargetPath = _a.sent();
                    if (spPath) {
                        realSpPath = '/' + spPath;
                        setSharePointItemsViewNavigationTargetPath(groupSmtp, realSpPath);
                    }
                    else {
                        setSharePointItemsViewNavigationTargetPath(groupSmtp, '');
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=mailGroupFilesRouteHandler.js.map